import React from "react";

const StackContext = React.createContext();
export default StackContext;
